
export default {
  name: 'LegacyNotice',
  mounted() {
    // optional auto logout or redirect handling
    this.logoutAndShowNotice();
  },
  methods: {
    logoutAndShowNotice() {
      // Clear local/session storage and cookies
      localStorage.clear();
      sessionStorage.clear();
      document.cookie.split(';').forEach(cookie => {
        document.cookie = cookie
          .replace(/^ +/, '')
          .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
      });
    }
  }
};
